import React, { useCallback, useState } from 'react';
import { message } from 'antd';
import { useExportCOC } from '../../hooks/useExportCOC';
import ExportCOCDropdown from '../../../components/ExportCOCDropdown';
import theme from '@/assets/theme';
import { themeT } from '@/utils/themeText';
import { COCExportCounts } from '@/pages/Shipments/components/ShipmentHeader';
import { CopyIcon, ChevronRightIcon } from '@/assets/icons/icons';
import { Flex } from 'antd';
import type { ShipmentRow } from '../../types';

interface ExportCOCWrapperProps {
  shipment: ShipmentRow;
}

const ExportCOCWrapper: React.FC<ExportCOCWrapperProps> = ({ shipment }) => {
  const { fetchCOCCount, handleClickExportCOC } = useExportCOC();
  const [cOCExportCounts, setCOCExportCounts] = useState<COCExportCounts>({});

  const handleFetchCOCCount = useCallback(async () => {
    try {
      const res = await fetchCOCCount(shipment);
      const data = res?.data;
      if (data) {
        if (data?.data?.is_success) {
          setCOCExportCounts(data?.data?.data || {});
        } else {
          message.error(data?.data?.message);
        }
      }
    } catch (_error) {
      console.error('Error fetching COC count:', _error);
    }
  }, [fetchCOCCount, shipment]);

  const handleExport = useCallback(
    async ({
      exportOptions,
    }: {
      exportOptions: Record<
        'statusUpdates' | 'comments' | 'alerts' | 'pods',
        boolean
      >;
    }) => {
      message.success(
        `${theme.themeType === 2 ? 'Transit history' : 'Chain of custody'} export started for ${cOCExportCounts?.selected_shipments} ${cOCExportCounts?.selected_shipments === 1 ? 'shipment' : 'shipments'}`
      );

      try {
        await handleClickExportCOC({ shipment, exportOptions });
      } catch (error) {
        console.error('Error exporting COC:', error);
      }
    },
    [handleClickExportCOC, shipment, cOCExportCounts]
  );

  return (
    <ExportCOCDropdown
      isDetialedView={true}
      fetchCOCCount={handleFetchCOCCount}
      cOCExportCounts={cOCExportCounts}
      trigger={
        <Flex justify='space-between' className='header-menu-item'>
          <Flex>
            <CopyIcon color='var(--text-primary)' />
            <span className='header-menu-item-content'>
              {`Export ${themeT(
                'chainOfCustody',
                theme.themeType
              )?.toLowerCase()}`}
            </span>
          </Flex>
          <ChevronRightIcon fill='var(--text-primary)' width={16} height={16} />
        </Flex>
      }
      canOpen={() => true}
      onExport={handleExport}
    />
  );
};

export default ExportCOCWrapper;
